
import { Typography } from "components/ui";
import React from "react";
import { DescribeLabel, DescribePanel } from "../styled";

const RulePanel = ({ describe, guide }) => {
    return (
        <DescribePanel style={{ flex: 4 }}>
            <DescribeLabel>
                <Typography $size="2em" $bolds $center>
                    {describe}
                </Typography>
                <Typography $size="1em" color="error" $center>
                    {guide}
                </Typography>
            </DescribeLabel>
        </DescribePanel>
    );
};

export default RulePanel;
